"use strict";

var _interopRequireDefault = require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
// progress bar
// progress bar style
// get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

function hasPermission(roles, permissionRoles) {
  // console.log(permissionRoles, 999)
  if (permissionRoles == undefined) return true;
  if (roles.indexOf('admin') >= 0) return true; // admin权限 直接通过
  // return permissionRoles.indexOf() >= 0
  return roles.some(function (role) {
    return permissionRoles.indexOf(role) >= 0;
  });
}
_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, roles, accessRoutes;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();

          // set page title
          document.title = (0, _getPageTitle.default)(to.meta.title);

          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.next = 35;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          _nprogress.default.done();
          _context.next = 33;
          break;
        case 9:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 14;
            break;
          }
          if (hasPermission(_store.default.getters.roles, to.meta.roles)) {
            // console.log(store.getters.roles, hasRoles,233)
            next(); //
          } else {
            next({
              path: '/401',
              query: {
                noGoBack: true
              }
            });
          }
          // next()
          _context.next = 33;
          break;
        case 14:
          _context.prev = 14;
          _context.next = 17;
          return _store.default.dispatch('user/getInfo');
        case 17:
          _yield$store$dispatch = _context.sent;
          roles = _yield$store$dispatch.roles;
          _context.next = 21;
          return _store.default.dispatch('permission/generateRoutes', roles);
        case 21:
          accessRoutes = _context.sent;
          // dynamically add accessible routes
          _router.default.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
            replace: true
          }));
          _context.next = 33;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](14);
          _context.next = 30;
          return _store.default.dispatch('user/resetToken');
        case 30:
          _elementUi.Message.error(_context.t0 || 'Has Error');
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 33:
          _context.next = 36;
          break;
        case 35:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
        case 36:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 26]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});